import { EditOutlined } from '@ant-design/icons'

import { pick } from '@eastcoal/common/utils/object'

import { MenuButton } from '../../../MenuButton'
import { useLinkCardStore } from '../../Store/hooks/useStore'

export const EditLinkButton = () => {
  const { nodeKey, openForm, toggleToolbarVisible } = useLinkCardStore(state =>
    pick(state, ['nodeKey', 'openForm', 'toggleToolbarVisible'])
  )

  const handleEditLink = () => {
    toggleToolbarVisible(false)
    openForm(nodeKey)
  }

  return (
    <MenuButton tooltip='编辑' onClick={handleEditLink}>
      <EditOutlined />
    </MenuButton>
  )
}
